export enum OneFranklinId {
  APAC = 'oneFranklinIdApac',
  EMEA = 'oneFranklinIdEmea',
  US = 'oneFranklinIdUs',
}
